import './MunMenu.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import fncS4 from '../mymod/commFunction4';
import HongButton from '../comm/HongButton';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import HongButtonNew from '../comm/HongButtonNew';
import Img2pdf from '../img2pdf/Img2pdf';
import HeaderTitle from '../comm/HeaderTitle';
import SaveTestApp from '../page_saveTest/SaveTestApp';
import SaveTestAppNew from '../page_saveTest_new/SaveTestApp_new';
import { FaSearch, FaTrashAlt, FaDatabase, FaPrint } from "react-icons/fa";
import { MdDeleteSweep } from "react-icons/md";
import { BsPrinter } from "react-icons/bs";
import { FiPrinter } from "react-icons/fi";
import { RiPrinterLine } from "react-icons/ri";

import { setIsModalSaveTest, setIsModalSaveTestNew, setListCart, setIsKeepCart, setIsFastSearch_saveTest } from '../reduxToolkit/redux';


const MunMenu = ({ setMunSolDap, onClearFromMenu }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listCart = useSelector((state) => state.reduxStore.listCart);
 
  const [list, setList] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [imgList, setImgList] = useState([]);
  const isModalSaveTest = useSelector((state) => state.reduxStore.isModalSaveTest);
  const isModalSaveTestNew = useSelector((state) => state.reduxStore.isModalSaveTestNew);
  const isFastSearch_saveTest = useSelector((state) => state.reduxStore.isFastSearch_saveTest);


  function onClickNew() {
    if (!window.confirm('선택된 문제를 모두 비우겠습니까?')) return;
    // setListCart([]);
    onClearFromMenu(true);
  }

 async function onClickPreview() {

    if (listCart.length === 0) {  
      alert('장바구니에 문제가 없습니다.');
      return;
    } 

    try {
      const imgListNew = await getRecords_detail_que(listCart); // await 추가
      setImgList(imgListNew);
      setIsModal(true);
    } catch (error) {
      console.error('이미지 로딩 실패:', error);
      alert('이미지를 불러오는데 실패했습니다.');
    }
  }


  async function getRecords_detail_que(listCart) {

    const records = [];
    const insertCommFileArray = [];
    
    try {
      for (let i = 0; i < listCart.length; i++) {

          const imgUrl = process.env.REACT_APP_imgUrl_S3;//web/kuesbImageLms
          const acaCode = fnc.getCookie('s3_acaCode');//이거 확인 하도록
          const folder = listCart[i]['폴더'].replaceAll('\\', '/');
          const imgFileName = listCart[i]['이미지코드'];
          const commQue = listCart[i]['공통지문'];
          
          let imagePath = await fncS4.getS3Path( `${imgUrl}/${acaCode}/${folder}/${imgFileName}`);   
          let imagePath_sol = await fncS4.getS3PathLong( `${imgUrl}/${acaCode}/${folder}/풀이_${imgFileName}`);
          let imagePath_comm = '';
          let kind = 'q'; // 모든 이미지를 문제로 처리
          if (commQue) {
              imagePath_comm = await fncS4.getS3PathLong( `${imgUrl}/${acaCode}/${folder}/${commQue}.gif`);
              kind = '@'; 
          } else {
              imagePath_comm ='';
          }


            if (imagePath_comm && !insertCommFileArray.includes(commQue)) {//공통지문이 있고, 아직 추가되지 않은 경우
              records.push({
                imagePath: imagePath_comm,
                imagePath_sol,
                imagePath_comm,
                문항번호: listCart[i]['문항번호'],
                유형: listCart[i]['유형'],
                kind: '@'
              });

              insertCommFileArray.push(commQue);
            }

          
          records.push({//문제
              imagePath,
              imagePath_sol,
              imagePath_comm,
              문항번호: listCart[i]['문항번호'],
              유형: listCart[i]['유형'],
              kind: 'q'
          });

      }
      

      return records;
      
    } catch (error) {
      console.error('getRecords_detail_que 에러:', error);
      throw error;
    }
  }



function onClicShowMun() {
 setMunSolDap('mun');
}
function onClickShowSol() {
  setMunSolDap('sol');
}

function onClickSaveTest() {

  dispatch(setIsModalSaveTest(true));

}

function onClickSaveTestNew() {

  navigate('/munMaual?isModalSaveTestNew=true'); // 새 저장소 페이지로 이동
  dispatch(setIsModalSaveTestNew(true));
}


function onSearch() {
  dispatch(setIsKeepCart(true)); 
  dispatch(setIsFastSearch_saveTest(true));
}
  //=========================================
  return (
<>
    <div className='MunMenu'>
    <section className='sec-main'>

       <HongButtonNew className='btn o2-btn-black'
            onClick={onSearch}>  
            <FaSearch />
            <p>검색</p>
        </HongButtonNew>

        <HongButtonNew className='btn o2-btn-black'
            onClick={onClickNew}>
              <FaTrashAlt />
              <p>clear</p>
        </HongButtonNew>


       <HongButtonNew className='btn o2-btn-black btnMunSol'
          onClick={onClicShowMun}>문제
        </HongButtonNew>

         <HongButtonNew className='btn o2-btn-black btnMunSol'
          onClick={onClickShowSol}>풀이
        </HongButtonNew>


      

        <HongButtonNew className='btn o2-btn-black'
            onClick={onClickPreview}>
              <FaPrint   />
              <p>미리보기</p>
        </HongButtonNew>

        {/* <HongButtonNew className='btn h-btn-red'
            onClick={onClickSaveTest}>저장소(구버전)
        </HongButtonNew> */}

         <HongButtonNew className='btn o2-btn-black'
            onClick={onClickSaveTestNew}>
              <FaDatabase />
            <p>저장소</p>
        </HongButtonNew>

       
        
    </section>
    </div>

    {isModal && <S.Modal_fixed>
        <Img2pdf imgList={imgList} setIsModal={setIsModal} />
    </S.Modal_fixed>}

    {isModalSaveTest && <S.Modal_fixed2>
        <SaveTestApp 
          listCart={listCart} 
          setListCart={setListCart}
        />
    </S.Modal_fixed2>}

     {isModalSaveTestNew && <S.Modal_fixed2>
        <SaveTestAppNew  
          listCart={listCart} 
          setListCart={setListCart}
        />
    </S.Modal_fixed2>}
</>
  );
};

export default MunMenu;